export const disguise = (userName = true) => {
    window.disguise(userName);
};

export default {
    disguise,
};
